// extracted by mini-css-extract-plugin
export default {"amountComplete":"LibraryLessonCardAmountComplete_amountComplete__Dfv2N"};